import { render } from "./Pagamenti.vue?vue&type=template&id=6400fbb3&scoped=true"
import script from "./Pagamenti.vue?vue&type=script&lang=js"
export * from "./Pagamenti.vue?vue&type=script&lang=js"

import "./Pagamenti.vue?vue&type=style&index=0&id=6400fbb3&scoped=true&lang=css"

import exportComponent from "/root/mymenucli/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6400fbb3"]])

export default __exports__